// 按页面划分
export default {
    // 公共页面
    common: {
        title: "ดาต้ามอลล์",
        pull_refresh: 'ดึงลงเพื่อรีเฟรช',
        release_refresh: 'ปล่อยเพื่อรีเฟรช',
        refresh_loading: 'กำลังโหลด...',
        footer_text: 'บริการ предоставляетсяโดย Ucloudlink (NASDAQ: UCL)'
    },
    home: {
        input_placeholder: 'ค้นหาประเทศ/ภูมิภาค',
        my_flow: 'ข้อมูลของฉัน',
        charge_code: 'รหัสคูปอง',
        coupons:'คูปอง',
        local_package: 'ข้อมูลท้องถิ่น',
        more: 'มากกว่า',
        popular_destination: 'ประเทศ/ภูมิภาค',
        buy_now: 'ซื้อตอนนี้',
        package_useing: 'เปิดใช้งาน',
        unused: 'ไม่เปิดใช้งาน',
        download_app: 'ดาวน์โหลดแอป',
        enter_the_mall_list: 'ไปที่ห้างสรรพสินค้า',
        no_data: 'ไม่มีข้อมูล',
        no_data_available: 'ไม่มีข้อมูล',
        copy_success: 'คัดลอกสำเร็จ',
        copy_fail: 'คัดลอกไม่สำเร็จ',
        meritsTitle: 'ข้อได้เปรียบคืออะไร？',
        merits1: 'ไม่จำเป็นต้องใช้ SIM & ไม่มีค่าใช้จ่ายรายเดือน',
        merits2: 'รวมออปเปอเรเตอร์ชั้นนำ 2-3 แบรนด์ สำหรับการเปลี่ยนเครือข่ายอัตโนมัติ',
        go_buy: 'ไปซื้อ',
        instant_savings: 'ประหยัด',
        expires_in: 'หมดอายุใน',
        download_app_tips: "ดาวน์โหลดแอป เพื่อรับโปรโมชันและประสบการณ์เพิ่มเติม"
    },
    packages: {
        sub_title: {
            us: 'ไม่รวมกวม ไซปัน',
            it: 'รวมทั้งนครวาติกัน ซานมารีโน',
            va: 'รวมทั้งอิตาลี,ซานมารีโน',
            sm: 'รวมทั้งอิตาลี นครวาติกัน',
            ma: 'รวมทั้งซาฮาราตะวันตกด้วย',
            eh: 'รวมทั้งโมร็อกโกด้วย',
            ch: 'รวมถึงลิกเตนสไตน์ด้วย',
            li: 'รวมทั้งสวิตเซอร์แลนด์ด้วย',
            fr: 'รวมถึงโมนาโกด้วย',
            mc: 'รวมทั้งประเทศฝรั่งเศสด้วย',
            fi: 'รวมทั้งหมู่เกาะโอลันด์ด้วย',
            ax: 'รวมทั้งประเทศฟินแลนด์ด้วย',
            gu: 'รวมทั้งหมู่เกาะนอร์เทิร์นมาเรียนาด้วย',
            mp: 'รวมถึงกวมด้วย'
        },
        unlimited_packages: 'แพ็คเกจข้อมูลไม่จำกัด',
        normal_packages: 'แพ็คเกจข้อมูลปกติ',
        multi_region_packages: 'หลายภูมิภาค',
        regional_data: 'ข้อมูลภูมิภาค',
        high_speed_text: 'ข้อมูลความเร็วสูง',
        infiniteFlow: 'ข้อมูลไม่ จำกัด',
        unLimitData: 'ไม่จำกัด',
        high_speed_text_year: 'ความเร็วสูง/mp',
        package_list: 'รายการแพ็คเกจ',
        special_offer: 'ลดราคา',
        first_month: 'เดือนแรก',
        periodUnit: {
            day: 'วัน',
            month: 'เดือน',
            hour: 'ชั่วโมง)',
            year: 'ปี',
        },
        periodUnits: {
            day: 'วัน',
            month: 'เดือน',
            hour: 'ชั่วโมง)',
            year: 'ปี',
        },
        periodUnitSimp: {
            day: 'ง',
            month: 'สำหรับ',
            hour: 'ชม.',
            year: 'ที่'
        },
        periodUnitMonthly:'รายเดือน',
        periodUnitsSimp: {
            day: 'ง',
            month: 'สำหรับ',
            hour: 'ชม.',
            year: 'ที่'
        },
        unlimited_good_name: {
            day: 'บัตรผ่านรายวัน',
            month: 'บัตรผ่านรายเดือน',
            year: 'บัตรผ่านรายปี'
        },
        continuousMonth: "เดือนต่อเนื่อง",
        continuousDay: "วันต่อเนื่อง",
        continuousYear: "ปีต่อเนื่อง",

        day_invalid: 'หมดอายุในวันที่ปัจจุบัน',
        month_invalid: 'หมดอายุในเดือนปัจจุบัน',
        immediate_valid: 'มีผลทันที',
        tomorrow_day_valid: 'มีผลตั้งแต่วันถัดไป',
        tomorrow_month_valid: 'มีผลตั้งแต่เดือนหน้าเป็นต้นไป',

        // detail page
        detail: {
            cell_flow: 'ข้อมูล',
            cell_period: 'ความถูกต้อง',
            buy_quantity: 'จำนวน',
            use_area: 'ความคุ้มครอง',
            use_intro: 'ข้อกำหนดและเงื่อนไข',
            buy_btn: 'คำสั่ง',
            pay: 'ชำระเงิน',
            buy_tips: 'คุณกำลังใช้แพ็คเกจ %@packageName อยู่ นี่แพ็คเกจนี้ซื้อไหม？',
            haveOrderTips: "สร้างคำสั่งซื้อค้างชำระแล้ว คลิกยืนยันเพื่อไปที่หน้าข้อมูลของฉัน！"
        },

        // confirm page
        confirm: {
            title: 'ยืนยันการสั่งซื้อ',
            real_pay_amount: 'จำนวนเงินที่ชำระ',
            online_payment: 'การชำระเงินออนไลน์',
            create_order_error: 'การตั้งค่าล้มเหลว'
        }
    },
    pay: {
        // result page
        result: {
            loading_order_status: 'กำลังรับสถานะคำสั่งซื้อ...',
            buy_success: 'คำสั่งซื้อเสร็จสมบูรณ์',
            buy_pending: 'รอการยืนยัน',
            buy_pending_tip: 'อยู่ระหว่างดำเนินการชำระเงิน…หากการชำระเงินไม่ได้รับการโอนภายใน 10 นาที โปรดติดต่อเราเพื่อขอความช่วยเหลือ',
            get_payment_info_fail: 'การรับข้อมูลการชำระเงินล้มเหลว',
            cell_package: 'บรรจุุภัณฑ์',
            cell_buy_amount: 'ผลรวมย่อย',
            cell_real_amount: 'จำนวนเงินที่ชำระ',
            go_to_order_btn: 'ไปที่แพ็คเกจของฉัน',
            back_home: 'กลับไปที่บ้าน',
            back_mall: 'กลับไปที่ห้างสรรพสินค้า',
            ordersn_empty: 'SN ของคำสั่งซื้อต้องไม่เว้นว่าง',
            order_search_error: 'ข้อผิดพลาดที่ไม่คาดคิด',
            goodsName:'ชื่อผลิตภัณฑ์'
        },

        //fail page
        fail: {
            payment_fail: 'การชำระเงินล้มเหลว',
            back_home: 'กลับไปที่บ้าน'
        }
    },
    CountryGroup: {
        title: "ประเทศ/ภูมิภาค",
        placeholder: "ค้นหาประเทศ/ภูมิภาค",
        clear: "ชัดเจน",
        history: "ประวัติการค้นหา"
    },
    PromotionCode: {
        verification: {
            title: 'รหัสคูปอง',
            minititle: 'รหัสคูปอง',
            input: 'กรุณากรอกรหัสเติมเงิน',
            explain: 'เคล็ดลับ: แตะปุ่มสแกนที่ด้านบนขวาเพื่อสแกนรหัส QR ของบัตรกำนัล หรือป้อนรหัสบัตรกำนัลด้วยตนเอง (คำนึงถึงตัวพิมพ์เล็กและตัวพิมพ์ใหญ่) หากไม่ได้ผล',
            submit: 'ส่ง',
            exchange: 'ไถ่ถอน',
            cancel: 'ยกเลิก',
            Inquiry: "แน่ใจว่าจะแลก.",
            ErrorCode: 'รหัสเติมเงินผิดพลาด',
        },
        recharge_success: {
            package: 'บรรจุุภัณฑ์',
            content: 'แลกสำเร็จแล้ว',
            back: 'กลับไปที่ห้างสรรพสินค้า',
            view_packets: 'ไปที่แพ็คเกจของฉัน'
        }
    },
    order: {
        state: {
            inUse: 'เปิดใช้งานแล้ว',
            isFirst: 'จัดลำดับความสำคัญ',
            toFirst: 'ตั้งค่าลำดับความสำคัญ',
            inactive: 'ปิดการใช้งาน'
        },
        periodUnits: {
            minute: 'นาที)',
            hour: 'ชั่วโมง)',
            day: 'วัน',
            month: 'เดือน',
        },
        useIntro: {
            tip1: 'แพ็กเกจข้อมูลแบบไม่จำกัดมีลำดับความสำคัญสูงกว่าแพ็กเกจข้อมูลแบบปริมาณ',
            tip2: 'ลำดับความสำคัญในการใช้งานจะขึ้นอยู่กับวันที่ซื้อแพ็คเกจประเภทเดียวกัน กล่าวคือ แพ็คเกจที่มีวันที่ซื้อเร็วที่สุดจะถูกใช้ก่อน ในขณะที่แพ็คเกจภูมิภาคเดียวจะมีลำดับความสำคัญสูงกว่าแพ็คเกจภูมิภาค',
            tip3: 'คุณยังสามารถปรับลำดับความสำคัญของการใช้แพ็กเก็ตประเภทเดียวกันได้ด้วยตนเอง'
        },
        myFlow: 'ข้อมูลของฉัน',
        remainingFlow: 'ข้อมูลเหลือ',
        remainingTime: 'เหลือที่ถูกต้อง',
        remainingHighFlow: 'ข้อมูลความเร็วสูงเหลืออยู่',
        validPeriod: 'ความถูกต้อง',
        noneFlow: 'ไม่มีแพ็คเกจข้อมูล',
        noneFlowTip: 'กรุณาซื้อแพ็คเกจข้อมูลและเพลิดเพลินกับเครือข่ายคุณภาพสูง',
        buyPackFlow: 'ซื้อแพ็คเกจ',
        checkInvalidFlow: 'ตรวจสอบแพ็คเกจข้อมูลที่หมดอายุ',
        orderList: {
            "title": "คำสั่งของฉัน",
            "amount_paid": "ทั้งหมด",
            "device": "อุปกรณ์ที่เป็นเจ้าของ",
            "order_details": "รายละเอียดการสั่งซื้อ",
            "total_amont": "ผลรวมย่อย",
            "orderSN": "หมายเลขคำสั่งซื้อ",
            "createTime": "เวลาแห่งการสร้างสรรค์",
            "cancelTime": "เวลาปิด",
            "payTime": "เวลาสั่ง",
            "unsubTime": "เวลาที่ยกเลิก",
            "payMethod": "วิธีการชำระเงิน",
            "thirdSN": "หมายเลขธุรกรรม",
            "delete": "ลบ",
            "cancel": "ยกเลิกคำสั่งซื้อ",
            "unsub": "คืนเงิน",
            "goto_cancel": "คุณต้องการยกเลิกคำสั่งซื้อหรือไม่?",
            "goto_unsubscribe": "คุณต้องการยกเลิกการสั่งซื้อหรือไม่?",
            "delete_Tips": "ไม่สามารถดำเนินการคำสั่งซื้อต่อได้หลังจากถูกลบไปแล้ว ดังนั้นปัญหาหลังการบริการของคุณจึงไม่สามารถจัดการได้คุณแน่ใจหรือว่าจะลบมัน?",
            "status_success": "สมบูรณ์",
            "status_pending": "ค้างชำระ",
            "status_cancel": "ปิด",
            "status_unsub": "ยกเลิก",
            "payMethod_stripe": "บัตรเครดิต"
          },
    },
    registerlogin: { 
        create_account_tip:"สร้างบัญชีเริ่มประสบการณ์พิเศษ",
        select_country_tip:"ใช้อุปกรณ์ในประเทศ/ภูมิภาค",
        email_name: "ส่งจดหมาย",
        phone_name: "โทรศัพท์",
        email_address: "ที่อยู่อีเมล",
        password: "รหัสผ่าน",
        country: "ประเทศ",
        select_country: "เลือกประเทศ",
        cancel: "ยกเลิก",
        confirm: "แน่นอน",
        please_enter:"โปรดป้อน 6-20 อักขระ (การรวมตัวอักษรตัวเลขหรือสัญลักษณ์)",
        select_country_tips: "การเลือกประเทศสำหรับการดูแพ็คเกจท้องถิ่น ไม่สามารถเปลี่ยนแปลงได้หลังจากการลงทะเบียน กรุณายืนยัน!",
        global_roaming: "รหัสโดเมนระหว่างประเทศ",
        phone_number: "หมายเลขโทรศัพท์",
        agree: "เห็นด้วย",
        user_agreement: "ข้อตกลงผู้ใช้",
        and: "และ",
        privacy_policy: "นโยบายความเป็นส่วนตัว",
        register_login: "ลงทะเบียนหรือเข้าสู่ระบบ",
        login_error: "จำนวนการเข้าสู่ระบบบ่อยเกินไปโปรดลองอีกครั้งในภายหลัง!",
        register_error: "จำนวนการลงทะเบียนบ่อยเกินไปโปรดลองอีกครั้งในภายหลัง!",
        forgot_pwd: "ลืมรหัสผ่าน",
        app_tips: "เข้าสู่ระบบแอพด้วยบัญชีนี้หลังจากดาวน์โหลดเพื่อเข้าถึงคุณสมบัติเพิ่มเติม",
        download_app: "ไปดาวน์โหลดแอพ",
        rememberPwd: "จำรหัสผ่าน",
        third_login: "ต่อด้วย",
        agreement_tips: "โปรดทำเครื่องหมายในช่องข้อตกลงผู้ใช้และนโยบายความเป็นส่วนตัว",
        selectCountry_tips: "โปรดทราบว่าประเทศที่ลงทะเบียนจะส่งผลโดยตรงต่อวิธีการชำระเงินและสกุลเงินต่อไปนี้ โปรดเลือกตามความต้องการของคุณ",
        login_error_cancel: "ผู้ใช้ยกเลิกการเข้าสู่ระบบ",
        login_error_auth: "กรุณาเปิดใช้งานป๊อปอัพจากการตั้งค่าเบราว์เซอร์",
        device_tips: "อุปกรณ์รอเปิดใช้งาน ประมวลผลภายใน 24 ชั่วโมง"
      },
      forgotPwd: {
        forgot_pwd: "ลืมรหัสผ่าน",
        email_address: "ที่อยู่อีเมล",
        next: "ต่อไป",
        email_has_been_sent: "เราได้ส่งอีเมลไปที่ %@email โปรดคลิกที่ลิงค์และทำตามขั้นตอนเพื่อดึงรหัสผ่านของคุณ",
        have_retrieved_it: "ฉันพบแล้ว",
        unable_to_receive_email: "ไม่สามารถรับอีเมลได้? โปรดตรวจสอบว่ามีอีเมลจาก %@email ภายใต้สแปมและไดเรกทอรีจดหมายที่ถูกลบ",
        or: "หรือ",
        resend: "ส่งคืน",
        global_roaming: "รหัสโดเมนระหว่างประเทศ",
        phone_number: "หมายเลขโทรศัพท์",
        verification_code_has_been_sent: "เราได้ส่งรหัสการยืนยันไปที่:",
        verification_code: "รหัสการตรวจสอบ",
        no_verification_code_received: "ไม่ได้รับรหัสการยืนยัน?",
        please_enter:"โปรดป้อน 6-20 อักขระ (การรวมตัวอักษรตัวเลขหรือสัญลักษณ์)",
        reset_password: "รีเซ็ตรหัสผ่าน",
        reset_successful: "รีเซ็ตสำเร็จ"
      },
      coupons: {
        coupons_name: "คูปอง",
        no_coupons: "ยังไม่มีคูปอง",
        no_data: "ยังไม่มีข้อมูล",
        applicable_to_the_following: "คูปองเหมาะสำหรับแพ็คเกจข้อมูลต่อไปนี้"
      },
      digital: {
        title: "อุปกรณ์ SN",
        purchased: "การซื้อของฉัน",
        viewAll: "มากกว่า",
        skinStore: "ร้านขายสินค้า",
        completed: "ซื้อ",
        goBuy: "ซื้อ",
        order: {
            title: "ซื้อคำสั่งซื้อ"
        },
        detail: {
            describe: "คำอธิบาย"
        }
    },
    viewPL: {
        other: 'อื่นๆ'
      },
    invalidFlow: {
        stateName: 'สถานะ',
        state: {
            NOT_ACTIVATED: "ปิดการใช้งาน",
            IN_USING: "มีอยู่",
            USE_END: "เหนื่อย",
            EXPIRE: "หมดอายุแล้ว",
            TRANSFER: "โอนย้าย",
            UNSUBSCRIBE: "ยกเลิก",
            VALID: "ถูกต้อง",
            INVALID: "ไม่ถูกต้อง",
            EXCHANGE_POINTS: "แลกคะแนน"
        },
        noneFlow: 'ไม่มีแพ็คเกจข้อมูลหมดอายุ',
        pageName: 'แพ็คเกจข้อมูลหมดอายุ'
    },
    flowDetail: {
        title: 'รายละเอียดข้อมูล',
        flow: 'ข้อมูล',
        validTime: 'รายละเอียดข้อมูล',
        invalidTime: 'ใช้ได้ถึงวันที่',
        coverage: 'ความคุ้มครอง',
        useIntro: 'ข้อกำหนดและเงื่อนไข',
        purchaseTime: 'ซื้อได้ที่',
        subtotal: 'ผลรวมย่อย',
        status: 'สถานะ',
        cancel: 'ยกเลิก',
        buyAgain: 'ซื้ออีกครั้ง',
        validity: 'ความถูกต้อง',
        tip: 'สังเกต',
        cancelTip: 'คุณแน่ใจหรือไม่ว่าต้องการคืนเงินแพ็คเกจนี้',
        dataLeft: 'ข้อมูลเหลือ'
    },
    netError: {
        try_again: 'ลองอีกครั้ง',
        net_error: 'ไม่มีเครือข่าย',
        try_again_desc: 'โปรดตรวจสอบการตั้งค่าเครือข่ายแล้วลองอีกครั้ง'
    },
    loadFail: {
        try_again: 'ลองอีกครั้ง',
        load_fail: 'การโหลดล้มเหลว',
        load_fail_desc: 'การโหลดข้อมูลล้มเหลว โปรดลองอีกครั้ง',
        IMEI_Not_Exist: 'ไม่มี IMEI โปรดลองเข้าจากทางเข้าที่ถูกต้อง',
        Project_Not_Exist: 'เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายบริการลูกค้า (01)',
        commonError: 'เกิดข้อผิดพลาด กรุณาติดต่อฝ่ายบริการลูกค้า',
    },
    settlement_Easy_and_convenient: "ง่ายและสะดวก",
    settlement_Great_deal: "มากมาย",
    settlement_Safe_and_secure: "ปลอดภัยและปลอดภัย",
    settlement_Autopay_service_regulation: "กฎระเบียบบริการอัตโนมัติ",
    settlement_Read: "อ่าน",
    settlement_No_coupon: "ไม่มีคูปองที่มีอยู่",
    settlement_Subtotal: "ผลรวมย่อย",
    settlement_Coupon: "คูปอง",
    settlement_TOTAL: "ทั้งหมด",
    settlement_promotion_tip: "ข้อเสนอส่งเสริมการขายไม่สามารถใช้ร่วมกับคูปองใด ๆ",
    settlement_coupon_tip: "คูปองไม่สามารถใช้ร่วมกับข้อเสนอส่งเสริมการขายอื่น ๆ ได้",
    member_myFlow_noList: "ไม่มีข้อมูล",
    detail_se_content: "วิธีที่ปลอดภัยง่ายและสะดวก คุณสามารถยกเลิกการสมัครได้ตลอดเวลา",
    Enter_Promo_code: "รหัสโปรโมชั่น",
    Enter_Promo_Coupon:"คูปอง",
    settlement_Not_used_coupon:"คูปองไม่ได้ใช้",
    settlement_Available_coupon:"มีอยู่",
    settlement_Unavailable_coupon:"ไม่สามารถใช้งานได้",
    please_Enter_Promo_code: "กรุณากรอกรหัสโปรโมชั่น",
    please_Select_Coupon_use:　"โปรดเลือกคูปองที่คุณต้องการใช้",
    Buy_Now: "ซื้อตอนนี้",
    Dont_Use_Any: "อย่าใช้ใด ๆ",
    settlement_confirm: "ยืนยัน",
    flowDetail_unsubscribe: "ยกเลิกการสมัคร",
    flowDetail_unsubscribed: "ถูกยกเลิกการสมัคร",
    flowDetail_isCancelPackage: "ยกเลิกการสมัครแพ็คเกจนี้?",
    flowDetail_confirmAgreementUnsubscribe: "คุณไม่สามารถมีข้อตกลงได้อย่างมากหลังจากยกเลิกการสมัคร แน่ใจหรือว่าต้องการยกเลิกการสมัคร",
    flowDetail_cancel: "ยกเลิก",
    flowDetail_cancelSuccess: "ยกเลิกการสมัครสำเร็จ",
    packages_detail_promotion: "การส่งเสริม",
    orderTips: {
        "iDay": "วัน",
        "iDays": "วัน",
        "iMonth": "เดือน",
        "iMonths": "เดือน",
        'First_charge_discount': "<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol ในการซื้อครั้งแรกของคุณ, จ่าย %@money/%@periodSymbol ในภายหลัง, คุณสามารถยกเลิกการสมัครได้ตลอดเวลา",
        'Monthly_discount': "บันทึก %@saveMoney แต่ละ %@period! คุณสามารถยกเลิกการสมัครได้ตลอดเวลา ",
        'Ordinary_monthly_package': "วิธีที่ปลอดภัยง่ายและสะดวก คุณสามารถยกเลิกการสมัครได้ตลอดเวลา",
        "AlreadyPurchased": 'ขออภัยที่คุณสามารถสมัครสมาชิกแพ็คเกจข้อมูลเดียวได้ในขณะนี้ โปรดยกเลิกการสมัครจาก“%@” และสมัครสมาชิกในภายหลังไปยังแพ็คเกจใด ๆ ที่คุณต้องการหลังจากหมดอายุ',
        "Contract_recommendation_First": '<label>ด้วยบริการ Autopay ในการซื้อครั้งแรกของคุณจ่ายเท่านั้น</label>'
            + '<p class="money">%@firstMoney</p>'
            + '<p class="SubscribeTips">คุณสามารถยกเลิกการสมัครได้ตลอดเวลา'
            + '<a class="btn">สมัครสมาชิก ></a></p>',
        "Contract_recommendation_Monthly_discount": "<label>ด้วยบริการ Autopay จ่ายเท่านั้น</label>"
            + '<p class="money">%@money</p>'
            + '<p class="SubscribeTips">คุณสามารถยกเลิกการสมัครได้ตลอดเวลา'
            + '<a class="btn">สมัครสมาชิก ></a></p>',
        "Contract_recommendation_General": "<label>ด้วยบริการ Autopay</label>"
            + '<p class="money">%@money</p>'
            + '<p class="SubscribeTips">ด้วยบริการ Autopay'
            + '<a href="javascript:;" class="btn">สมัครสมาชิก ></a></p>',
        'BanlanceDoubleCheck': 'แน่ใจหรือว่าต้องการจ่ายด้วยยอดคงเหลือ?',
    },
    feedback: {
        title: "ข้อเสนอแนะ",
        placeholder: "โปรดเข้าสู่ประเทศที่คุณต้องการเยี่ยมชมหรือคำถามอื่น ๆ และเราจะตอบสนองความต้องการของคุณโดยเร็วที่สุด!",
        submit: "ส่ง",
        submit_success: "ส่งสำเร็จ",
        other_opinions: "ความคิดเห็นอื่นๆ"
    },
    view_country_input: 'กรุณากรอกบัญชีของคุณ',
    select_package: {
        title: "เลือกดาต้า",
        allPackage: 'ดาต้าทั้งหมด',
        type: "ประเภท",
        flow: "ดาต้า",
        month_package: "แพลนรายเดือน",
        flow_package: "แพ็คเกจข้อมูล",
        time: "ระยะเวลาใช้งาน",
        period: "รอบจ่าย/ไซเคิล",
        auto_debit: "ข้อมูลการโอนเงินอัตโนมัติ",
        auto_subscribe: "อัตโนมัติต่ออายุ",
        detail: "รายละเอียดดาต้า",
        carrier: "โอเปอเรเตอร์ที่รองรับ",
        country: "ประเทศที่ครอบคลุม",
        notice: "คู่มือการซื้อ"
      }
}